export type UrbanHeatIslandTractFact = {
  uhii_percentile: number | null;
  deg_hour_day: number | null;
};

export type UrbanHeatIslandSummaryFacts = {
  locationName: string;
  tractCount: number | null;
  tractsWithData: number;
  medianUhiiDegHourDay: number | null;
  medianPercentile: number | null;
  minUhii: number | null;
  maxUhii: number | null;
  highUhiTractCount: number;
  lowUhiTractCount: number;
  sourceVintage: string;
};

function median(values: number[]): number | null {
  if (!values.length) return null;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];
}

/**
 * Summarize tract-level UHII fields without conflating modeled index (deg-hour-day) with percentile rank.
 */
export function summarizeUrbanHeatIslandTracts(
  locationName: string,
  tracts: UrbanHeatIslandTractFact[],
  sourceVintage = 'CalEPA Urban Heat Island Index (modeled tract results)'
): UrbanHeatIslandSummaryFacts {
  const degValues: number[] = [];
  const pctValues: number[] = [];
  let high = 0;
  let low = 0;

  tracts.forEach((t) => {
    if (t.deg_hour_day != null && Number.isFinite(t.deg_hour_day)) {
      degValues.push(t.deg_hour_day);
    }
    if (t.uhii_percentile != null && Number.isFinite(t.uhii_percentile)) {
      pctValues.push(t.uhii_percentile);
      if (t.uhii_percentile >= 80) high += 1;
      if (t.uhii_percentile < 20) low += 1;
    }
  });

  const minUhii = degValues.length ? Math.min(...degValues) : null;
  const maxUhii = degValues.length ? Math.max(...degValues) : null;

  return {
    locationName,
    tractCount: tracts.length > 0 ? tracts.length : null,
    tractsWithData: pctValues.length,
    medianUhiiDegHourDay: median(degValues),
    medianPercentile: median(pctValues),
    minUhii,
    maxUhii,
    highUhiTractCount: high,
    lowUhiTractCount: low,
    sourceVintage,
  };
}
